import {
  ArmchairIcon,
  BookIcon,
  ShoppingBagIcon as DefaultIcon,
  DumbbellIcon,
  FlowerIcon,
  FootprintsIcon,
  GamepadIcon,
  GemIcon,
  GiftIcon,
  HammerIcon,
  PackageIcon,
  ShirtIcon,
  ShoppingBasketIcon,
  ShoppingCartIcon,
  SmartphoneIcon,
  SparklesIcon,
  StoreIcon,
  WrenchIcon,
} from 'lucide-react';

import {
  SHOPPING_CONFIG,
  SHOPPING_CONTEXT_KEYWORDS,
  SHOPPING_KEYWORDS,
  VALID_SHOPPING_SUBCATEGORIES,
  detectShoppingSubcategory,
  detectShoppingSubcategoryWithConfidence,
} from '@splitfiesta/core';

export {
  SHOPPING_CONFIG,
  SHOPPING_CONTEXT_KEYWORDS,
  SHOPPING_KEYWORDS,
  VALID_SHOPPING_SUBCATEGORIES,
  detectShoppingSubcategory,
  detectShoppingSubcategoryWithConfidence,
};

type ShoppingIcon = React.ComponentType<{ className?: string }>;

export const SHOPPING_SUBCATEGORY_ICONS: Record<string, ShoppingIcon> = {
  clothes: ShirtIcon,
  electronics: SmartphoneIcon,
  groceries: ShoppingCartIcon,
  online: PackageIcon,
  furniture: ArmchairIcon,
  gifts: GiftIcon,
  services: WrenchIcon,
  shoes: FootprintsIcon,
  books: BookIcon,
  toys: GamepadIcon,
  mall: StoreIcon,
  market: ShoppingBasketIcon,
  department: StoreIcon,
  jewelry: GemIcon,
  cosmetics: SparklesIcon,
  sports: DumbbellIcon,
  hardware: HammerIcon,
  garden: FlowerIcon,
  default: DefaultIcon,
};

export function getShoppingIcon(
  subcategory: string | null | undefined
): ShoppingIcon {
  if (!subcategory || !(subcategory in SHOPPING_SUBCATEGORY_ICONS)) {
    return SHOPPING_SUBCATEGORY_ICONS.default;
  }
  return SHOPPING_SUBCATEGORY_ICONS[subcategory];
}
